var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWaze({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#31C6F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1503 26.8337C46.5984 26.8337 40.4897 29.7774 36.3673 35.0042C33.4958 38.6845 31.9503 43.2489 31.9503 47.8864V51.7872C31.9503 53.48 31.2878 55.0997 30.1833 56.2774C29.3003 57.1614 28.1958 57.8239 27.0181 58.1186C27.4601 59.222 28.4905 60.9149 30.3306 62.7561C31.8772 64.3747 33.7173 65.6997 35.7048 66.6569V66.5837C36.9556 64.6694 39.0173 63.5649 41.2984 63.5649C41.7405 63.5649 42.1083 63.6391 42.5503 63.7122C45.2003 64.2274 47.2609 66.2891 47.7772 68.8649H53.2234C58.8923 68.8649 64.2655 66.5095 68.1673 62.6819C74.203 56.6462 76.0431 47.5917 72.7306 39.7891C69.4181 31.9122 61.7628 26.8337 53.1503 26.8337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.1508 24.1844C45.8633 24.1844 39.0178 27.4227 34.3803 33.2378C31.0678 37.4344 29.3008 42.587 29.3008 47.9602V51.7878C29.3008 53.7753 27.9027 55.6155 25.1785 55.7628C24.516 55.7628 24.0008 56.278 23.9277 56.9405C23.8535 58.7075 25.7678 62.02 28.4178 64.67C30.258 66.5102 32.3928 67.9825 34.674 69.1602C33.9383 73.2094 37.1035 76.8897 41.2258 76.8897H41.299C44.4652 76.8897 47.1152 74.6817 47.7777 71.6628H53.2982C53.8865 74.6817 56.5365 76.8897 59.7758 76.8897C60.5115 76.8897 61.3213 76.7424 62.058 76.5219C63.8982 75.9325 65.2963 74.5344 65.9588 72.6932C66.5482 71.0003 66.474 69.3075 65.9588 67.9094C67.4311 66.9522 68.7561 65.9219 70.008 64.67C74.4982 60.253 77.0008 54.2174 77.0008 47.9602C77.0008 41.6299 74.4982 35.7405 70.008 31.2503C65.5178 26.6128 59.4811 24.1844 53.1508 24.1844ZM53.1508 26.8344C61.6902 26.8344 69.4186 31.987 72.7311 39.8628C76.0436 47.7397 74.2035 56.7932 68.1678 62.7567C64.266 66.6575 58.8928 68.9397 53.224 68.9397H47.7777C47.2615 66.2897 45.2008 64.3022 42.5508 63.787C42.1088 63.7128 41.741 63.6397 41.299 63.6397C39.091 63.6397 36.9561 64.7442 35.7053 66.6575V66.7317C33.7178 65.7003 31.9508 64.3753 30.3311 62.8299C28.491 60.9897 27.4607 59.2227 27.0186 58.1924C28.2705 57.8977 29.3008 57.2352 30.1838 56.3522C31.2883 55.1003 31.9508 53.5549 31.9508 51.862V47.9602C31.9508 43.3227 33.4963 38.7594 36.3678 35.078C40.4902 29.7049 46.599 26.8344 53.1508 26.8344Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.7507 39.9382C62.2783 39.9382 61.1006 41.1158 61.1006 42.5882C61.1006 44.0605 62.2783 45.2382 63.7507 45.2382C65.223 45.2382 66.4007 44.0605 66.4007 42.5882C66.4007 41.1158 65.223 39.9382 63.7507 39.9382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8513 39.9382C46.379 39.9382 45.2013 41.1158 45.2013 42.5882C45.2013 44.0605 46.379 45.2382 47.8513 45.2382C49.3236 45.2382 50.5013 44.0605 50.5013 42.5882C50.5013 41.1158 49.3236 39.9382 47.8513 39.9382Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.408 50.4644C46.4519 50.4644 45.7894 51.4215 46.2303 52.3045C47.9974 55.9859 51.6777 58.3412 55.8 58.3412C59.9224 58.3412 63.6027 55.9859 65.3697 52.3045C65.7375 51.4215 65.1482 50.4644 64.192 50.4644C63.6769 50.4644 63.2349 50.759 63.0144 51.2011C61.6894 53.9242 58.892 55.6912 55.8732 55.6912C52.7822 55.6912 49.9849 53.9242 48.733 51.2011C48.4394 50.759 47.9974 50.4644 47.408 50.4644Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(24 24)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/Waze.4611d9b18e900edb75355f17c1b52a87.svg";
export { ForwardRef as ReactComponent };